<app-funnel-shell>
  <div class="funnel-card funnel-payment">
    <h1>{{ 'funnel.payment.title' | translate }}</h1>

    @if (loading()) {
      <p class="funnel-card__intro">{{ 'funnel.payment.loading' | translate }}</p>
    }

    @if (error()) {
      <div class="alert alert-danger" role="alert">{{ error() }}</div>

      <div class="funnel-payment__password mt-3">
        @if (pwSent() !== null) {
          <div class="alert alert-success" role="alert">
            {{ 'funnel.payment.password_sent' | translate: { email: pwSent() } }}
          </div>
        } @else {
          <p class="funnel-card__intro">{{ 'funnel.payment.set_password_hint' | translate }}</p>
          <button
            type="button"
            class="btn btn-outline-secondary w-100"
            [disabled]="pwBusy()"
            (click)="onSetPassword()"
          >
            {{ (pwBusy() ? 'funnel.payment.password_sending' : 'funnel.payment.set_password_cta') | translate }}
          </button>
          @if (pwError()) {
            <div class="alert alert-danger mt-2" role="alert">
              {{ 'funnel.payment.password_error' | translate }}
            </div>
          }
        }
      </div>
    }

    @if (!loading() && recipientAddress() && orderId(); as oid) {
      <app-web3-confirmation
        [orderId]="oid"
        [totalPrice]="totalPrice()"
        [recipientAddress]="recipientAddress()"
        (onSuccess)="onWeb3Success()"
        (onBack)="onWeb3Back()"
      />
    }
  </div>
</app-funnel-shell>
